module.exports = __webpack_public_path__ + "img/IMG_5834.cbc32cbf.jpg";